import request from '@/services/interceptor.js'

export const get_listaAuditor = () => {
    return request({
        url: 'auditor',
        method: 'get',
        noLoadingBar: true
    })
};

export const get_assegnazioniAuditor = () => {
    return request({
        url: 'auditor/assegnazioni',
        method: 'get',
        noLoadingBar: true
    })
};

export const assegna_azienda_auditor = (par) => {
    return request({
        url: 'auditor/assegna',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const rimuovi_assegnazione_auditor = (par) => {
    return request({
        url: 'auditor/rimuovi',
        method: 'post',
        data: par,
        loadingBar: true
    })
};

export const crea_auditor = (par) => {
    return request({
        url: 'auditor/nuovo',
        method: 'post',
        data: par,
        loadingBar: true
    })
};
